/**
 * @flow
 * @relayHash 24b19a869d216c89530838a069ba2765
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type EmailPurchaseOrderInput = {|
  purchaseOrderId: string
|};
export type EmailPurchaseOrderMutationVariables = {|
  input: EmailPurchaseOrderInput
|};
export type EmailPurchaseOrderMutationResponse = {|
  +emailPurchaseOrder: {|
    +success: boolean
  |}
|};
export type EmailPurchaseOrderMutation = {|
  variables: EmailPurchaseOrderMutationVariables,
  response: EmailPurchaseOrderMutationResponse,
|};
*/


/*
mutation EmailPurchaseOrderMutation(
  $input: EmailPurchaseOrderInput!
) {
  emailPurchaseOrder(input: $input) {
    success
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "EmailPurchaseOrderInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "emailPurchaseOrder",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "EmailPurchaseOrderPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "success",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "EmailPurchaseOrderMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "EmailPurchaseOrderMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "EmailPurchaseOrderMutation",
    "id": null,
    "text": "mutation EmailPurchaseOrderMutation(\n  $input: EmailPurchaseOrderInput!\n) {\n  emailPurchaseOrder(input: $input) {\n    success\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '93e0fb6db014a2be1e29e1ea26782acc';
module.exports = node;
